import OtsEditor from "./OtsEditor"

OtsEditor.install = Vue => {
    vue.component(OtsEditor.name,OtsEditor)
}


export default OtsEditor